export default {
  C: "C",
  CSharp: "C♯",
  D: "D",
  DFlat: "D♭",
  DSharp: "D♯",
  E: "E",
  EFlat: "E♭",
  F: "F",
  FSharp: "F♯",
  G: "G",
  GFlat: "G♭",
  GSharp: "G♯",
  A: "A",
  AFlat: "A♭",
  ASharp: "A♯",
  B: "H",
  BFlat: "H♭",

  correctExcl: "Správně!",
  wrongExcl: "Chyba!",

  ABORT: "KONEC",

  lastRound: "Minulé cvičení",
  score: "Skóre",
  accuracy: "Přesnost",
  correct: "Správně",
  wrong: "Špatně",

  START: "START",
  settings: "Nastavení",
  ROUND_LENGTH: "DÉLKA CVIČENÍ",
  NOTE_INPUT: "ZADÁVÁNÍ NOT",
  CLEF: "NOTOVÝ KLÍČ",
  DIFFICULTY: "OBTÍŽNOST",
  ACCIDENTALS: "PŮLTÓNY",
  LANGUAGE: "JAZYK",
  twentySeconds: "20 s",
  oneMinute: "1 minuta",
  fiveMinutes: "5 minut",
  infinite: "Nekonečná",
  buttons: "Tlačítka",
  piano: "Klávesy",
  trebleClef: "Houslový",
  bassClef: "Basový",
  altoClef: "Altový",
  tenorClef: "Tenorový",
  easy: "Snadná",
  normal: "Normální",
  hard: "Těžká",
  none: "Žádné",
  sharp: "♯",
  flat: "♭",
  sharpAndFlat: "♯ a ♭",
  SOUND: "ZVUK",
  VIBRATION: "VIBRACE",
  DISPLAYCORRECTNOTE: "ZOBRAZIŤ SPRÁVNU NOTU",
  on: "Zapnut",
  off: "Vypnut",

  TIME: "ČAS",
  CORRECT: "SPRÁVNĚ",
  ACCURACY: "PŘESNOST",
  SCORE: "SKǑRE",

  record: "Nejvyšší skóre",
  history: "Dějiny"
};



// WEBPACK FOOTER //
// ./src/resources/cz.js